import { resetAllowedCommandsCache } from './Knowledge/KnowledgeUtils';
import { clearFlowQueueNotice, clearTrainerNameCache } from './Tasks/TaskUtils';
import { resetCloseWalkOverride } from './Tasks/useCloseWalkOverride';
import { resetTrainingEnabled } from './Training/useTrainingEnabled';
import { resetCodeLabels } from './Codes/codesUtils';
import { clearTroubleshootingCache } from './Troubleshooting/troubleshootingCache';

/**
 * Per-person answers held for the life of the tab: the allowed-command list, the roster name,
 * whether training is open, whether the close walk is overridden, the code labels (a
 * promise with no key at all), the stored offline copy of the troubleshooting pages and a queued-close rejection nobody has shown yet. The shared iPad changes hands inside one tab, and a manager can
 * move between a Google session and a PIN session, so every sign-in and sign-out drops them all
 * or the next person inherits the last one's menus, name and codes.
 */
export const resetUserCaches = () => {
    resetAllowedCommandsCache();
    clearTrainerNameCache();
    resetCloseWalkOverride();
    resetTrainingEnabled();
    resetCodeLabels();
    clearFlowQueueNotice();
    clearTroubleshootingCache();
};
